const initialState = {
  data: null,
  status: 'empty', // empty, loading, success
  errorMessage: '',
};

const getters = {
  data: state => state.data,
  status: state => state.status,
  errorMessage: state => state.errorMessage,
};

const mutations = {
  SET_DATA(state, data) {
    state.data = data;
  },
  SET_STATUS(state, status) {
    state.status = status;
  },
  SET_ERROR_MESSAGE(state, val) {
    try {
      if (val) state.errorMessage = val.errors[0].message;
    } catch {
      state.errorMessage = 'Terjadi gangguan. Silakan coba lagi nanti.';
    }
  },
};

const actions = {
  async fetch({ commit, rootState, rootGetters }, payload) {
    const walletToggle = rootGetters['mitra-wallet/governmentRevenue'];
    const inquiryPayload = { ...payload };
    if (payload.category === 'other' && !walletToggle) {
      delete inquiryPayload.category;
      delete inquiryPayload.subcategory;
    }
    commit('SET_STATUS', 'loading');
    try {
      let data;
      if (walletToggle) {
        const response = await rootState.apiService.inquiryBuka20({
          customer_number: inquiryPayload.payment_code,
          product_code: inquiryPayload.subcategory,
          transaction_type: 'government-revenue',
        });
        const listMetadataName = new Set([
          'payment_code',
          'tax_identification_number',
          'customer_name',
          'customer_account',
          'customer_address',
          'tax_code',
          'tax_period',
          'tax_assessment_number',
          'tax_object_number',
          'customer_id',
          'document_type',
          'document_number',
          'document_date',
          'control_service_code',
          'institution_name',
          'echelon_unit',
          'work_unit',
          'bill_count',
          'partner_name',
        ]);
        const metadataMappingName = {
          bill_count: 'detail_count',
          partner_name: 'partner',
        };
        // eslint-disable-next-line unicorn/no-array-reduce
        const listMetadata = response?.customer_transaction_inquiry?.metadata_list.reduce(
          (data, metadata) => ({
            ...data,
            ...(metadata?.name && listMetadataName.has(metadata?.name)
              ? { [metadataMappingName[metadata.name] || metadata.name]: metadata.value }
              : {}),
          }),
          {}
        );
        data = {
          ...response?.customer_transaction_inquiry,
          ...listMetadata,
          category: inquiryPayload.category,
        };
      } else {
        const response = await rootState.apiService.inquiry(inquiryPayload);
        data = response.data;
      }
      commit('SET_DATA', data);
      commit('SET_STATUS', 'success');
      commit('SET_ERROR_MESSAGE', '');
      return data;
    } catch (error) {
      commit('SET_DATA', null);
      commit('SET_STATUS', 'error');
      commit('SET_ERROR_MESSAGE', error);
      throw error;
    }
  },
};

export default {
  getters,
  actions,
  mutations,
  namespaced: true,
  state: () => ({ ...initialState }),
};
